import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactCard = ({ icon, title, description, action, actionLabel, iconColor = "var(--color-primary)" }) => {
  return (
    <div className="bg-card rounded-xl p-6 md:p-8 border border-border hover:shadow-lg transition-all duration-300 card-hover">
      <div className="flex flex-col items-center text-center space-y-4">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary/10 flex items-center justify-center">
          <Icon name={icon} size={32} color={iconColor} strokeWidth={2} />
        </div>
        <div className="space-y-2">
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            {title}
          </h3>
          <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>
        <Button
          variant="default"
          size="lg"
          onClick={action}
          className="w-full button-hover"
        >
          {actionLabel}
        </Button>
      </div>
    </div>
  );
};

export default ContactCard;